import React from 'react'
import * as ReactDOM from 'react-dom/client'
import controllerLoadedObservableFactory from '@newswebsiteapp/shared/observables/controllerLoadedObservableFactory'
import getRootElementAndDataAndKeys from '@newswebsiteapp/shared/react/utils/getRootElementAndDataAndKeys'
import CommonProviders from '@newswebsiteapp/shared/react/CommonProviders'
import App from './App'
import swal from 'sweetalert2'

controllerLoadedObservableFactory('conference').subscribe(async () => {
  const modalFields_note_show = true
  const {
    recaptchaSiteKey,
    recaptchaSiteKey_disabled,
    dataFromServer,
    collectJSPromise,
    rootElement,
  } = getRootElementAndDataAndKeys({
    rootElementId: '#signup-form-root',
    modalFields_note_show,
  })

  ReactDOM.createRoot(rootElement).render(
    <CommonProviders collectJSPromise={collectJSPromise}>
      <App
        recaptchaSiteKey={recaptchaSiteKey}
        recaptchaSiteKey_disabled={recaptchaSiteKey_disabled}
        dataFromServer={dataFromServer}
        modalFields_note_show={modalFields_note_show}
      />
    </CommonProviders>,
  )
})

// // https://newswebsite.com/events/spring2024?buy_success=true
// import getSearchParam from '@newswebsiteapp/shared/lib/getSearchParam'

controllerLoadedObservableFactory('conference').subscribe(() => {
  // Check if the query parameter 'nmi_successful_transid' is present in the current location
  // const transactionId = getSearchParam('nmi_successful_transid', window.location.href)
  // const queryString = window.location.search
  // const urlParams = new URLSearchParams(queryString)
  // console.log(urlParams)
  // const transactionIdHas = urlParams.has('nmi_successful_transid')
  // const transactionId = urlParams.get('nmi_successful_transid')

  const transactionId = window.location.href.includes('buy_success')

  if (transactionId) {
    // Do something if 'nmi_successful_transid' is present
    // console.log('Transaction ID:', transactionId)
    // Perform additional actions or redirect if needed

    swal.fire({
      title: 'Donation was successful',
      text: 'Your donation has been successfully submitted. Thank you for your support.',
      icon: 'success',
      confirmButtonText: 'Close',
    })
  } else {
    // Do something else if 'nmi_successful_transid' is not present
    console.log('Transaction ID not found')
  }
})
